module.exports = __webpack_public_path__ + "img/Residential bungalow - Kolhapur.ff23fa56.jpg";